import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiServerPath } from "api_server";
import "./styles.css";

const DeletionPage: React.FC = () => {
  const [id, setId] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    // Get ID from URL query parameters
    const getParamFromUrl = () => {
      if (window.location.search) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const userId = params.get("id");
        if (userId) {
          setId(userId);
        } else {
          setError("Invalid deletion request - missing user ID parameter");
          setLoading(false);
        }
      } else {
        setError("Invalid deletion request - missing user ID parameter");
        setLoading(false);
      }
    };

    getParamFromUrl();
  }, []);

  useEffect(() => {
    const handleDeletionRequest = async () => {
      if (!id) {
        setError("Invalid deletion request - missing user ID");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.post(
          `${ApiServerPath.API_SERVER_BASE_URL}${ApiServerPath.UTILITIES_REQUEST_DELETE_USER}`,
          {
            uid: id,
          }
        );

        const responseData = response.data as {
          success?: boolean;
          results?: {
            success?: boolean;
            message?: string;
          };
        };

        if (responseData?.success && responseData?.results?.message) {
          setMessage(responseData.results.message);
        } else {
          setError("Failed to process deletion request");
        }
      } catch (err) {
        console.error("Error processing deletion request:", err);
        setError("An error occurred while processing your request");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      void handleDeletionRequest();
    }
  }, [id]);

  const getMessageType = (message: string) => {
    if (message.includes("sent")) {
      return "info";
    } else if (message.includes("deleted")) {
      return "success";
    } else if (message.includes("already")) {
      return "warning";
    }
    return "info";
  };

  if (loading) {
    return (
      <div className="deletion-container">
        <div className="deletion-card">
          <div className="loading-spinner"></div>
          <h2>Processing your request...</h2>
          <p>Please wait while we process your deletion request.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="deletion-container">
        <div className="deletion-card error">
          <div className="icon error-icon">⚠️</div>
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  const messageType = getMessageType(message);

  return (
    <div className="deletion-container">
      <div className={`deletion-card ${messageType}`}>
        <div className={`icon ${messageType}-icon`}>
          {messageType === "success" && "✅"}
          {messageType === "warning" && "⚠️"}
          {messageType === "info" && "ℹ️"}
        </div>
        <h2>Account Deletion Request</h2>
        <p className="message">{message}</p>
        <div className="additional-info">
          <p>
            If you have any questions or need assistance, please contact our
            support team plai@plai.app.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeletionPage;
